var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer-container"},[_c('p',{staticClass:"copyright-text"},[_vm._v("Copyright © "+_vm._s(_vm.year)+" Superintendence of Cultural Heritage ® All Rights Reserved.")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"engineered-by-arkafort"},[_c('p',[_vm._v("Engineered by")]),_c('img',{attrs:{"src":require("../assets/Arkafort-logo.svg"),"alt":"Arkafort"}})])
}]

export { render, staticRenderFns }